import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

export enum PullToRefreshPages {
    JourneyPlannerResults,
    TicketList
}

@Injectable({ providedIn: 'root' })
export class PullToRefreshService {
    private _pullToRefreshCallSource = new Subject<void>();
    private _pageSource = new BehaviorSubject<PullToRefreshPages>(null);

    methodCalled$ = this._pullToRefreshCallSource.asObservable();

    isPullToRefreshEnabled$ = this._pageSource.asObservable().pipe(
        map((page) => {
            const enabledPages = [PullToRefreshPages.JourneyPlannerResults, PullToRefreshPages.TicketList];
            return enabledPages.includes(page);
        })
    );

    callPullToRefresh(): void {
        this._pullToRefreshCallSource.next();
    }

    enablePullToRefresh(page: PullToRefreshPages): void {
        this._pageSource.next(page);
    }

    disablePullToRefresh(): void {
        this._pageSource.next(null);
    }
}
